import { defineMessages } from 'react-intl';

export default defineMessages({
  filterLabel: {
    id: 'frontbucket.repository.pullrequest.fileTree.filterLabel',
    description:
      'Label for the text input where users can filter files by their filename',
    defaultMessage: 'Filter files',
  },
});
